/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

type MemoizedFunction<T, R> = (arg: T, ...rest: unknown[]) => R;

export function memoize<T = unknown, R = unknown>(
  fn: MemoizedFunction<T, R>,
): MemoizedFunction<T, R> {
  const cache = new Map<T, R>();
  return (arg, ...rest) => {
    const cached = cache.get(arg);

    if (cached) {
      return cached;
    }

    const val = fn(arg, ...rest);
    cache.set(arg, val);
    return val;
  };
}
